(function(){
    let mediaQueryResult =  window.matchMedia("(max-width: 749px)"),
    accordionHeadings = document.querySelectorAll(".AccordionTitle"),
    accordionContent = document.querySelectorAll('.AccordionContent'),
    implementAccordion = mediaQueryResult => {
        if(mediaQueryResult.matches){
            hidePanels();
            accordionHeadings.forEach((heading, index) => {
                heading.addEventListener('click', (e)=>{
                    let heading = e.currentTarget;
                    (heading.nextElementSibling.style.maxHeight)? hidePanels() : showPanel(heading);
                })
            })
        }
    },
    showPanel = element => {
        hidePanels();
        element.classList.add("active");
        element.nextElementSibling.style.maxHeight = element.nextElementSibling.scrollHeight + "px";
    },
    hidePanels = () => {
        accordionHeadings.forEach((heading, index) => {
            if(accordionContent[index]) accordionContent[index].style.maxHeight = null;
            heading.classList.remove('active');
        });
    },
    init = () => {
        implementAccordion(mediaQueryResult);
        mediaQueryResult.addEventListener('change', implementAccordion);
    };
    init();
})();